import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "headerDesktop" }
const _hoisted_2 = { class: "headerDesktop_userWrapper" }
const _hoisted_3 = { class: "headerDesktop_avatar" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "headerDesktop_user" }
const _hoisted_6 = { class: "headerDesktop_name" }
const _hoisted_7 = {
  key: 1,
  class: "headerDesktop_email"
}
const _hoisted_8 = {
  key: 0,
  class: "headerDesktop_menu"
}
const _hoisted_9 = ["href", "data-analytics-element-target", "data-analytics-element-name"]
const _hoisted_10 = { class: "headerDesktop_itemName" }
const _hoisted_11 = { class: "headerDesktop_itemName" }
const _hoisted_12 = { class: "headerDesktop_itemName" }
const _hoisted_13 = { class: "headerDesktop_itemName" }
const _hoisted_14 = { class: "headerDesktop_itemName" }
const _hoisted_15 = { class: "headerMain_itemName" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_menu_top = _resolveComponent("menu-top")!
  const _component_points_label = _resolveComponent("points-label")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: _ctx.PAGE_NAME.HOME }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(['headerDesktop_logo', `-${_ctx.projectId}`]),
          style: _normalizeStyle({
          backgroundImage: `url(${_ctx.logo.src})`,
          maskImage: `url(${_ctx.logo.src})`
        })
        }, null, 6)
      ]),
      _: 1
    }, 8, ["to"]),
    _createVNode(_component_menu_top),
    _createElementVNode("div", {
      class: "headerDesktop_userBlock",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.user.avatar,
            alt: "",
            class: "headerDesktop_photo"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.username), 1),
          (_ctx.userScoreAmount > 0)
            ? (_openBlock(), _createBlock(_component_points_label, {
                key: 0,
                points: _ctx.userScoreAmount,
                "only-text": ""
              }, null, 8, ["points"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.email), 1))
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["headerDesktop_setting", { '-open': _ctx.menuOpen }])
      }, null, 2),
      (_ctx.menuOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.user.isAdmin)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "headerDesktop_item",
                  href: _ctx.urlAdmin,
                  "data-analytics": "",
                  "data-analytics-element-type": "menu_user",
                  "data-analytics-element-target": _ctx.urlAdmin,
                  "data-analytics-element-id": "dashboard",
                  "data-analytics-element-name": _ctx.$t('dashboard')
                }, [
                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "headerDesktop_itemIcon -ext" }, null, -1)),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('dashboard')), 1)
                ], 8, _hoisted_9))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: { name: _ctx.PAGE_NAME.EDIT_PROFILE },
              class: "headerDesktop_item",
              "data-analytics": "",
              "data-analytics-element-type": "menu_user",
              "data-analytics-element-target": { name: _ctx.PAGE_NAME.EDIT_PROFILE },
              "data-analytics-element-id": _ctx.PAGE_NAME.EDIT_PROFILE,
              "data-analytics-element-name": _ctx.$t('editProfile')
            }, {
              default: _withCtx(() => [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "headerDesktop_itemIcon -userEdit" }, null, -1)),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('editProfile')), 1)
              ]),
              _: 1
            }, 8, ["to", "data-analytics-element-target", "data-analytics-element-id", "data-analytics-element-name"]),
            _createVNode(_component_router_link, {
              to: { name: _ctx.PAGE_NAME.POINTS },
              class: "headerDesktop_item",
              "data-analytics": "",
              "data-analytics-element-type": "menu_user",
              "data-analytics-element-target": { name: _ctx.PAGE_NAME.POINTS },
              "data-analytics-element-id": _ctx.PAGE_NAME.POINTS,
              "data-analytics-element-name": _ctx.$t('points')
            }, {
              default: _withCtx(() => [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "headerDesktop_itemIcon -points" }, null, -1)),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('Points')) + " " + _toDisplayString(_ctx.projectName), 1)
              ]),
              _: 1
            }, 8, ["to", "data-analytics-element-target", "data-analytics-element-id", "data-analytics-element-name"]),
            (_ctx.isShowVideoConsultations)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: { name: _ctx.PAGE_NAME.VIDEO_CONSULTATIONS },
                  class: "headerDesktop_item",
                  "data-analytics": "",
                  "data-analytics-element-type": "menu_user",
                  "data-analytics-element-target": { name: _ctx.PAGE_NAME.VIDEO_CONSULTATIONS },
                  "data-analytics-element-id": _ctx.PAGE_NAME.VIDEO_CONSULTATIONS,
                  "data-analytics-element-name": _ctx.$t('videoConsultations.VideoConsultations')
                }, {
                  default: _withCtx(() => [
                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "headerDesktop_itemIcon -videoconsultations" }, null, -1)),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('videoConsultations.VideoConsultations')), 1)
                  ]),
                  _: 1
                }, 8, ["to", "data-analytics-element-target", "data-analytics-element-id", "data-analytics-element-name"]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: { name: _ctx.PAGE_NAME.SETTINGS },
              class: "headerDesktop_item",
              "data-analytics": "",
              "data-analytics-element-type": "menu_user",
              "data-analytics-element-target": { name: _ctx.PAGE_NAME.SETTINGS },
              "data-analytics-element-id": _ctx.PAGE_NAME.SETTINGS,
              "data-analytics-element-name": _ctx.$t('settings')
            }, {
              default: _withCtx(() => [
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "headerDesktop_itemIcon -settings" }, null, -1)),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('Settings')), 1)
              ]),
              _: 1
            }, 8, ["to", "data-analytics-element-target", "data-analytics-element-id", "data-analytics-element-name"]),
            _createVNode(_component_router_link, {
              to: { name: _ctx.PAGE_NAME.LOGOUT },
              class: "headerDesktop_item",
              "data-analytics": "",
              "data-analytics-element-type": "menu_user",
              "data-analytics-element-target": { name: _ctx.PAGE_NAME.LOGOUT },
              "data-analytics-element-id": _ctx.PAGE_NAME.LOGOUT,
              "data-analytics-element-name": _ctx.$t('logout')
            }, {
              default: _withCtx(() => [
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "headerDesktop_itemIcon -logout" }, null, -1)),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('logout')), 1)
              ]),
              _: 1
            }, 8, ["to", "data-analytics-element-target", "data-analytics-element-id", "data-analytics-element-name"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}